module.exports = __webpack_public_path__ + "img/loader-34.10f9c9b2.gif";